import apis from './apis'
import competitors from './competitors'
import permissions from './permissions'
import colors from './colors'
import theme from './theme'

export const Competitors = competitors
export const Apis = apis
export const Permissions = permissions
export const Colors = colors
export const Theme = theme


// WEBPACK FOOTER //
// ./src/constants/index.js